import styled from 'styled-components';
import BottomModal from '../../../components/modal/BottomModal';
import { PeriodFilter } from './PeriodFilter';
import WeekDatePicker from './WeekDateFilter';
import { useState } from 'react';
import { startOfISOWeek, endOfISOWeek } from 'date-fns';

interface Props {
  isMonth: boolean;
  date: { from: Date; to: Date };
  setDate: React.Dispatch<React.SetStateAction<{ from: Date; to: Date }>>;
  onClose: () => void;
}

function DateModal({ isMonth, date, setDate, onClose }: Props) {
  const [localDate, setLocalDate] = useState<{ from: Date; to: Date }>(date);

  const handleConfirm = () => {
    // console.log(localDate);
    setDate(localDate);
    onClose();
  };

  return (
    <BottomModal onClose={onClose}>
      <Header>기간 선택</Header>
      {isMonth ? (
        <PeriodFilter
          from={localDate.from}
          to={localDate.to}
          onChange={(from, to) => setLocalDate({ from, to })}
        />
      ) : (
        <WeekDatePicker
          value={localDate.from}
          initialMonth={localDate.from}
          onChange={(picked) => {
            const from = startOfISOWeek(picked);
            const to = endOfISOWeek(picked);
            setLocalDate({ from, to });
          }}
        />
      )}
      <Bottom>
        <CancleButton onClick={onClose}>취소</CancleButton>
        <ConfirmButton onClick={handleConfirm}>적용</ConfirmButton>
      </Bottom>
    </BottomModal>
  );
}

export default DateModal;

const Header = styled.div`
  display: flex;
  padding: 24px 20px 8px 20px;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;

  color: #0c0e12;
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: -0.36px;
`;

const Bottom = styled.div`
  display: flex;
  align-self: stretch;
  padding: 16px 24px 24px 24px;
  align-items: center;
  gap: 8px;
`;

const Button = styled.button`
  border: none;
  outline: none;

  display: flex;
  height: 44px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;

  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.3px;
`;

const CancleButton = styled(Button)`
  background: #f4f5f7;
  color: #424854;
`;

const ConfirmButton = styled(Button)`
  background: #3f6ef1;
  color: rgba(244, 245, 247, 0.88);
  flex: 1 0 0;
`;
